module.exports = __webpack_public_path__ + "img/2.e9c4b480.svg";